import Button from '../ui/Button.jsx';
import { Card, CardBody, CardHeader } from '../ui/Card.jsx';
import HeadingOne from '../ui/HeadingOne.jsx';
import { useEffect } from 'react';

const Result = ({ ...props }) => {
    const { heading, subheading, image, text, button, action, fn, feedback, formData  } = props;
    let buttonAction = { };

    useEffect(() => {
        const [actionName, actionValue] = action.split(':');
        if('onload.send' === actionName && formData) {
            fn.handleSend(actionValue)
        }
    }, []);

    return (
        <div className="component-message">

            <div className="row justify-center">
                <div className="col lg:w-10/12">
                    <div className="text-center">
                        {/*<HeadingOne heading={feedback?.heading ?? heading} />*/}
                        {/*<img src={image} className="mx-auto"/>*/}
                        {/*<h2 className="mt-12">{feedback?.title ?? ''}</h2>*/}
                        {/*<div className="mb-12" dangerouslySetInnerHTML={{ __html: feedback?.message ?? '' }}></div>*/}

                        <Card>
                            <CardHeader heading={feedback?.heading ?? heading} image={image}/>
                            <CardBody>
                                <h2>{feedback?.title ?? ''}</h2>
                                <div className="mb-12" dangerouslySetInnerHTML={{ __html: feedback?.message ?? '' }}></div>
                                <div className="flex flex-col gap-8 text-left">
                                    {feedback?.answers?.map((answer, index) => (
                                        <div className="text-base">
                                            <div className="text-bold">{answer.title }</div>
                                            <div className="text-teal-200">{ answer.correct_answer }</div>
                                            {answer.isTruth === false && (
                                                <div className="text-red-200 line-through">{ answer.user_answer }</div>
                                            )}
                                        </div>
                                    ))}
                                </div>

                                <div className="mt-12">
                                    <Button type="white" onClick={() => fn.handleAction(feedback?.action)}>Pokračuj</Button>
                                </div>
                            </CardBody>
                        </Card>
                       </div>
                </div>
            </div>
        </div>
    );
};

export default Result;
